module.exports = __webpack_public_path__ + "img/welms_pic_ru.89748891.png";